@if (approvalPercentage > 0) {
  <div class="chart-card" [class.filter-active]="isFilterOpen">
    <div class="chart-container">
      <div class="chart-custom-size">
        <ngx-charts-pie-chart
          [scheme]="colorScheme"
          [results]="resultPercentage"
          [labels]="false"
          [doughnut]="true"
          [arcWidth]="0.6"
          [tooltipDisabled]="true"
        >
        </ngx-charts-pie-chart>
      </div>
      <div class="chart-percentage">{{ approvalPercentage }}%</div>
    </div>
    <div class="chart-text">{{ chartTitle }}</div>
  </div>
}

@if (approvalPercentage == 0) {
  <div class="chart-card">
    <app-no-data-container
      [firstParagraph]="'pages.QUIZ-CHARTS.ERROR-ANSWERS-GRAPHIC' | transloco"
      [isChartCard]="true"
    >
    </app-no-data-container>
  </div>
}
